import AdminPage from '@/pages/AdminPage';

const AdminProductsPage = () => {
  return <AdminPage />;
};

export default AdminProductsPage;